<template>
  <div class="DialogUpdateProfileUser__Component">
    <form @submit.prevent="updateFullName" novalidate="true">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">עדכון שם משתמש</p>
          <button type="button" class="delete" @click="$emit('close', true)" />
        </header>
        <section class="modal-card-body">
          <b-field label="שם משתמש">
            <b-input v-model="fullName" :disabled="isLoading" />
          </b-field>
        </section>
      </div>
      <footer class="modal-card-foot">
        <b-button
          native-type="submit"
          :loading="isLoading"
          label="שמור"
          type="is-primary"
        />
        <b-button
          :loading="isLoading"
          label="סגור"
          @click="$emit('close')"
        />
      </footer>
    </form>
  </div>
</template>

<script>
import ProfileService from "@/services/ProfileService";
import { ToastProgrammatic as Toast } from "buefy";

export default {
  name: "DialogUpdateProfileUser",
  props: ["userId", "fullName", "onSuccess"],
  data() {
    return {
      isLoading: false,
    };
  },
  created() {
    this.userId = this.$props.userId;
    this.fullName = this.$props.fullName;
  },
  methods: {
    updateFullName() {
      if (!this.fullName || this.fullName.trim() === "") {
        Toast.open({
          type: "is-danger",
          message: "שדה חובה!",
          duration: 8000,
        });
        return;
      }
      this.isLoading = true;
      ProfileService.updateUserFullName(this.userId, this.fullName.trim()).then(() => {
      }).catch((error) => {
        Toast.open({
          type: "is-danger",
          message: error.response?.data?.ModelState[""][0] || "קרתה תקלה, לא היה ניתן לשמור את השינויים!",
          duration: 8000,
        });
      }).finally(() => {
        this.isLoading = false;
        this.$emit("close");
        this.onSuccess();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.DialogUpdateProfileUser__Component {
  .modal-card {
    .modal-card-head {
      .modal-card-title {
        font-size: 1.5rem;
      }
    }
    .modal-card-body {
      padding: 1rem;
    }
  }
  .modal-card-foot {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 1rem;
    border-top: 1px solid #e0e0e0;
  }
}
</style>
